export default __webpack_public_path__ + "static/media/Nakaset.3aca0d2c.jpg";